import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
} from "@mui/material";

type ConfirmDeleteDialogProps<T> = {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    target: T | null;
    getDisplayText: (target: T) => string;
};

export default function ConfirmDeleteDialog<T>({
    open,
    onCancel,
    onConfirm,
    target,
    getDisplayText,
}: ConfirmDeleteDialogProps<T>) {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
                <Typography>Are you sure you want to delete this item?</Typography>
                {target && (
                    <Typography variant="subtitle2" color="error" sx={{ mt: 1 }}>
                        {getDisplayText(target)}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>
                <Button onClick={onConfirm} color="error" variant="contained">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
